import { css } from 'styled-components';

// after 가 들어가는 박스의 카드 세트 -------------------------------
export const cardDefaultStyle = css`
  border-width: var(--cardBorderWithImgWidth);
  border-radius: var(--cardBorderRadius);
  backdrop-filter: blur(var(--cardBlur, 4px));
  background: var(--cardBackgroundColor);
  border: 1px solid var(--lineColor);
  corner-shape: var(--cardCornerShape);

  /* z-index: 1; */
`;

export const cardBorderImg = css`
  /* border-image-source: url('https://universe.leagueoflegends.com/images/space_odyssey_border.svg'); */

  border-style: var(--cardBorderType);
  border-width: var(--cardBorderWidth);
  border-color: var(--cardLineColor);
  border-radius: var(--cardBorderRadius);
  box-sizing: border-box;
  corner-shape: var(--cardCornerShape);

  border-image-outset: var(--cardBorderOffset);
  border-image-slice: 30;
  border-image-source: var(--cardBorderImage);
  border-image-width: 30;
  transition: border-image-source 0.3s ease-in-out;
  // 이게 있으면 메뉴 위를 박스가 침범합니다
  // but 없으면 보더 이미지가 안먹혀? 그런듯
  z-index: 1;
`;
// after 가 들어가는 박스의 카드 세트 -------------------------------

export const cardCommonStyle = css`
  border: var(--cardBorderWidth) var(--cardBorderType) var(--cardLineColor);
  border-radius: var(--cardBorderRadius);
  backdrop-filter: blur(var(--cardBlur, 4px));
  background: center / cover no-repeat var(--cardBackgroundColor);
  overflow: hidden;
  box-sizing: border-box;
  corner-shape: var(--cardCornerShape);
  ${cardBorderImg}
`;

export const cardLineStyle = css`
  border: var(--cardBorderWidth) var(--cardBorderType) var(--cardLineColor);
  border-radius: var(--cardBorderRadius);
  background: var(--cardBackgroundColor);
  backdrop-filter: blur(var(--cardBlur, 4px));
`;
